export const ADD_TO_CART = "ADD_TO_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const INCREASE_QTY = "INCREASE_QTY"
export const DECREASE_QTY = "DECREASE_QTY"